<template>
           
                <div class="container my-auto">
                    <div class="copyright text-center my-auto">
                        <span>Copyright &copy; PARAPAL L-CRM 1403</span>
                    </div>
                </div>
           
</template>